import { isDefined } from "@shared/utils";
import { Observable } from "rxjs";
import { filter } from "rxjs/operators";

export function filterDefined<T>() {
  return (source$: Observable<null | undefined | T>) => source$.pipe(filter(isDefined));
}
